export default "__VITE_ASSET__Cymce1Bp__"